export default __webpack_public_path__ + "static/media/iq.50d96638.svg";